"use client";
import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";

import "./team-section-card.scss";

export interface TeamMember {
    name: string;
    position: string;
    image?: string | null;
    bioLink?: string;
    bioTarget?: "_self" | "_blank";
    bioText?: string;
}

export function TeamCard({name, position, image, bioLink, bioTarget, bioText}: TeamMember): JSX.Element {
    return (
        <div className="team-card">
            <div className="team-card__image">{image && <SmartImage src={image} alt={name} width={500} height={500} />}</div>

            <div className="team-card__content">
                <Typography as="h3" size={{desktop: 20, mobile: 14}} weight={500}>
                    {name}
                </Typography>

                <Typography as="p" size={{desktop: 16, mobile: 12}} color="paragraph" weight={400} className="team-card__position">
                    {position}
                </Typography>

                <Link href={bioLink || "#"} className="team-card__link" target={bioTarget || "_self"}>
                    {bioText || "Read Bio"}
                </Link>
            </div>
        </div>
    );
}
